export default __webpack_public_path__ + "static/media/switchOn.3e34ef08.svg";